import React, { useState } from 'react';
import Popup from '../Popup';
import Input from "../Input";

import './styles.css';
import { FaPen } from 'react-icons/fa';


export default function PopupNewPassword(props) {
    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            icon={<FaPen/>}
            tittle="Nova Senha"
        >
            <form className='new-password-form-container' action="">
                <Input
                    label='Senha*'
                    placeholder="Senha"
                    id='new-password-form-password'
                    onChange={(event) => props.setPassword(event.target.value)}
                    value={props.password}
                />
                <Input
                    label='Confirmação de senha*'
                    placeholder="Confirme a senha"
                    id='new-password-form-confirm-password'
                    onChange={(event) => props.setConfirmPassword(event.target.value)}
                    value={props.confirmPassword}
                />
                <button type='button' onClick={props.onClick}>{props.buttonTitle}</button>
            </form>
        </Popup>
    )
}
